import { useLingui } from '@lingui/react/macro'
import { Box } from 'designSystem/components/Box'
import { Button } from 'designSystem/components/Button'
import { DropdownMenuTrigger } from 'designSystem/components/DropdownMenu'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'designSystem/components/Tooltip'
import { ChevronDown, ChevronUp, CircleAlert } from 'lucide-react'
import React from 'react'

export type RevisionDropdownTriggerProps = {
  label: string
  isOutdated: boolean
  isOpen: boolean
  outdatedTooltip: string
  size: 'xs' | 'lg'
}

export function RevisionDropdownTrigger({
  label,
  isOutdated,
  isOpen,
  outdatedTooltip,
  size,
}: RevisionDropdownTriggerProps): React.ReactElement {
  const { t } = useLingui()
  const trigger = (
    <DropdownMenuTrigger asChild>
      <Button
        type='button'
        variant={isOutdated ? 'warningRaised' : 'inputRaised'}
        size={size}
        aria-label={
          isOutdated ? t`Drawing revision is out of date` : t`Drawing revision`
        }>
        {isOutdated && <CircleAlert />}
        {label}
        {isOpen ? <ChevronUp /> : <ChevronDown />}
      </Button>
    </DropdownMenuTrigger>
  )

  if (!isOutdated) return trigger

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Box display='inlineFlex'>{trigger}</Box>
      </TooltipTrigger>
      <TooltipContent side='top' sideOffset={8} zIndex='overlay'>
        {outdatedTooltip}
      </TooltipContent>
    </Tooltip>
  )
}
